import { Card } from "@omni/ui/components/Card/card";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    balance: number;
};

const BonusCardBalance = ({ balance }: Props) => {
    const { t } = useGranite();
    return (
        <Card>
            <Card.Body>
                <Card.Title tag="h2">
                    {t("general.bonusCardRequestBalance.title")}
                </Card.Title>
                <span>{t("general.bonusCardRequestBalance.balance")}: </span>
                <span className={cn("tw:font-bold tw:text-danger tw:text-lg")}>
                    {balance}
                </span>
            </Card.Body>
        </Card>
    );
};

export default BonusCardBalance;
